export function HasPermittedPrefix(rfidHex?: string, prefixes?: string[]) {
    if (prefixes === undefined) return true;
    if (rfidHex === undefined) return false;
    return prefixes.filter(p => rfidHex.startsWith(p)).length > 0;
}
